import React from "react";
import { Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import FooterBottom from "./components/FooterBottom";
import Footer from "./components/Footer/Footer";
import Home from "./pages/Home";  
import About from "./pages/About";
import Services from "./pages/Services";
import Contact from "./api/Contact";
import CustomFlyersPrintingServices from "./components/Services/CustomFlyersPrintingServices";
import CertificatePrintingServices from "./components/Services/CertificatePrintingServices";
import BusinessCardPrinting from "./components/Services/BusinessCardPrinting";
import CustomEnvelopes from "./components/Services/CustomEnvelopes";
import CustomNotepads from "./components/Services/CustomNotepads";
import StampsandEmbossers from "./components/Services/StampsandEmbossers";
import DoorHangerPrinting from "./components/Services/DoorHangerPrinting";
import CustomNoteCards from "./components/Services/CustomNoteCards";
import CustomPocketFolder from "./components/Services/CustomPocketFolder";
import SchoolCopyPrinting from "./components/Services/SchoolCopyPrinting";
import DocumentPrintingAndBinding from "./components/Services/DocumentPrintingAndBinding";
import PostcardPrintingandDesigning from "./components/Services/PostcardPrintingandDesigning";
import PresentationPrinting from "./components/Services/PresentationPrinting";
import RackCardDesign from "./components/Services/RackCardDesign";
import StickersAndLabels from "./components/Services/StickersAndLabels";
import TableTentCardPrinting from "./components/Services/TableTentCardPrinting";
import PrintingofBags from "./components/Services/PrintingofBags";
import PrintingOfHangtags from "./components/Services/PrintingOfHangtags";
import AcePrints from "./components/Services/AcePrints";
import Blueprints from "./components/Services/Blueprints";
import FloorGraphics from "./components/Services/FloorGraphics";
import WallGraphics from "./components/Services/WallGraphics";
import WindowGraphics from "./components/Services/WindowGraphics";
import BannersSignsAndPosters from "./components/Services/BannersSignsAndPosters";
import PrintingofBoxes from "./components/Services/PrintingofBoxes";
import PrintingofPostItNotes from "./components/Services/PrintingofPostItNotes";
import CarMagnets from "./components/Services/CarMagnets";
import PrintingofFabricBackdrops from "./components/Services/PrintingofFabricBackdrops";
import PrintingofFabricTableThrows from "./components/Services/PrintingofFabricTableThrows";
import FlutterFlags from "./components/Services/FlutterFlags";
import PrintingofMenus from "./components/Services/PrintingofMenus";
import FabricBanners from "./components/Services/FabricBanners";
import LargeTripodBanners from "./components/Services/LargeTripodBanners";
import IndoorBanners from "./components/Services/IndoorBanners";
import OutdoorBanners from "./components/Services/OutdoorBanners";
import RetractableBanners from "./components/Services/RetractableBanners";
import StationaryBanners from "./components/Services/StationaryBanners";
import TableTopBanners from "./components/Services/TableTopBanners";
import CorrugatedPlasticSign from "./components/Services/CorrugatedPlasticSign";
import PrintingofFlags from "./components/Services/PrintingofFlags";
import SegGraphics from "./components/Services/SegGraphics";
import StyreneSigns from "./components/Services/StyreneSigns";
import TableSigns from "./components/Services/PrintingofTableSigns";
import Signboards from "./components/Services/Signboards";
import BacklitPosters from "./components/Services/BacklitPosters";
import PosterPrints from "./components/Services/PosterPrints";
import PhotoPosters from "./components/Services/PhotoPosters";
import Announcements from "./components/Services/Announcements";
import WhatsAppButton from "./components/WhatsAppButton";
import PrintingCard from "./components/Services/PrintingCards";
import Invitations from "./components/Services/Invitations";
import NoteCards from "./components/Services/NoteCards";
import Postcards from "./components/Services/Postcards";
import Automotive from "./components/Services/Automotive";
import Education from "./components/Services/Education";
import EventsAndFestivals from "./components/Services/EventsAndFestivals";
import ThankYouCards from "./components/Services/ThankyouCards";
import RealEstate from "./components/Services/RealEstate";
import Restaurant from "./components/Services/Restaurant";
import Retail from "./components/Services/Retail";
import Travel from "./components/Services/Travel";
import ScrollToTop from "./ScrollToTop";
import 'bootstrap/dist/css/bootstrap.min.css';
import './components/Header.css';
import MegaMenu from "./components/header/MegaMenu";
import './App.css'
const App = () => {
  return (
    <>
    <ScrollToTop />
      {/* Common Header */}
      <MegaMenu />
      
      {/* Main Content */}
      <main>
        <Routes>
          
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/contact" element={<Contact />} />
          {/* Corrected CustomFlyersPrintingServices route */}
          <Route path="/custom-flyers-printing-services" element={<CustomFlyersPrintingServices />} />
          <Route path="/certificate-printing-services" element={<CertificatePrintingServices />} />
          <Route path="/business-card-printing" element={<BusinessCardPrinting />} />
          <Route path="/custom-envelops" element={<CustomEnvelopes />} />
          <Route path="/custom-notepads" element={<CustomNotepads />} />
          <Route path="/stamps-and-embossers" element={<StampsandEmbossers />} />
          <Route path="/door-hanger-printing" element={<DoorHangerPrinting />} />
          <Route path="/custom-note-cards" element={<CustomNoteCards />} />
          <Route path="/custom-pocket-folder" element={<CustomPocketFolder />} />
          <Route path="/school-copy-printing" element={<SchoolCopyPrinting />} />
          <Route path="/document-printing-and-binding" element={<DocumentPrintingAndBinding />} />
          <Route path="/postcard-printing-and-designing" element={<PostcardPrintingandDesigning />} />
          <Route path="/presentation-printing" element={<PresentationPrinting />} />
          <Route path="/rack-card-design" element={<RackCardDesign />} />
          <Route path="/printing-of-stickers-and-labels" element={<StickersAndLabels />} />
          <Route path="/printing-of-hangtags" element={<PrintingOfHangtags />} />
          <Route path="/table-tent-card-printing" element={<TableTentCardPrinting />} />
          <Route path="/printing-of-bags" element={<PrintingofBags />} />
          <Route path="/architecture-construction-and-engineering-prints" element={<AcePrints />} />
          <Route path="/printing-blueprints" element={<Blueprints />} />
          <Route path="/floor-graphics" element={<FloorGraphics />} />
          <Route path="/wall-graphics" element={<WallGraphics />} />
          <Route path="/window-graphics" element={<WindowGraphics />} />
          <Route path="/banners-signs-and-posters" element={<BannersSignsAndPosters />} />
          <Route path="/printing-of-boxes" element={<PrintingofBoxes />} />
          <Route path="/printing-of-post-it-notes" element={<PrintingofPostItNotes />} />
          <Route path="/car-magnets" element={<CarMagnets />} />
          <Route path="/printing-of-fabric-backdrops" element={<PrintingofFabricBackdrops />} />
          <Route path="/printing-of-fabric-table-throws" element={<PrintingofFabricTableThrows />} />
          <Route path="/printing-of-flutter-flags" element={<FlutterFlags />} />
          <Route path="/printing-of-menu" element={<PrintingofMenus />} />
          <Route path="/printing-of-fabric-banners" element={<FabricBanners />} />
          <Route path="/large-tripod-banners" element={<LargeTripodBanners />} />
          <Route path="/indoor-banners" element={<IndoorBanners />} />
          <Route path="/outdoor-banners" element={<OutdoorBanners />} />
          <Route path="/printing-of-retractable-banners" element={<RetractableBanners />} />
          <Route path="/printing-of-stationary-banners" element={<StationaryBanners />} />
          <Route path="/printing-table-top-banners" element={<TableTopBanners />} />
          <Route path="/printing-corrugated-plastic-signs" element={<CorrugatedPlasticSign />} />
          <Route path="/printing-of-flags" element={<PrintingofFlags />} />
          <Route path="/seg-graphics-printing" element={<SegGraphics />} />
          <Route path="/sytrene-sign-printing" element={<StyreneSigns />} />
          <Route path="/printing-table-signs" element={<TableSigns />} />
          <Route path="/printing-signboards" element={<Signboards />} />
          <Route path="/printing-backlit-posters" element={<BacklitPosters />} />
          <Route path="/poster-prints" element={<PosterPrints />} />
          <Route path="/photo-posters-printing" element={<PhotoPosters />} />
          <Route path="/printing-of-announcements" element={<Announcements />} />
          <Route path="/printing-greeting-cards" element={<PrintingCard />} />
          <Route path="/printing-invitations" element={<Invitations />} />
          <Route path="/printing-of-notecards" element={<NoteCards />} />
          <Route path="/printing-of-postcards" element={<Postcards />} />
          <Route path="/automotive-printing" element={<Automotive />} />
          <Route path="/printing-for-education" element={<Education />} />
          <Route path="/events-and-festivals" element={<EventsAndFestivals />} />
          <Route path="/printing-thankyou-cards" element={<ThankYouCards />} />
          <Route path="/realestate-printing" element={<RealEstate />} />
          <Route path="/restaurants-printing" element={<Restaurant />} />
          <Route path="/retail-printing" element={<Retail />} />
          <Route path="/travel-printing" element={<Travel />} />
        </Routes>
      </main>
      <WhatsAppButton />
      {/* Common Footer */}
      <Footer />
      <FooterBottom />
    </>
  );
};

export default App;
